import { Component, Input, OnInit } from "@angular/core";
import { CommonModule } from '@angular/common';
import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { BackendApiService } from "../../../../app/services/backend-api.service";
import { BaseUrlConstantsService } from "../../../../app/services/base-url-constants.service";

// Import your child components...
import { DiagnosticsSummaryComponent } from "./diagnostics-summary/diagnostics-summary.component";
import { VelocitySpectraComponent } from "./velocity-spectra/velocity-spectra.component";
import { AccelerationSpectraComponent } from "./acceleration-spectra/acceleration-spectra.component";
import { CepstrumSpectraComponent } from "./cepstrum-spectra/cepstrum-spectra.component";
import { BearingAnalysisComponent } from "./bearing-analysis/bearing-analysis.component";
@Component({
  selector: 'app-piezo-diagnostics',
  templateUrl: './diagnostics.component.html',
  styleUrls: ['./diagnostics.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    NgbNavModule,
    DiagnosticsSummaryComponent,
    VelocitySpectraComponent,
    AccelerationSpectraComponent,
    CepstrumSpectraComponent,
    BearingAnalysisComponent
  ]
})
export class PiezoDiagnostics implements OnInit {
  @Input() data: any;

  public loadingCompanyDetails: boolean = false;
  public companyName: string = "";
  public siteName: string = "";
  public applicationName: string = "";
  public serialNumber: string = "";
  public assetName: string = "";
  public clientId: string | null = null;
  public active_inner_tab = 'inner-1';

  // RPM Logic Variables
  public loadingRPM: boolean = false;
  public rpmData: any = null; // Store the full object to handle Gear vs Standard logic

  constructor(private service: BackendApiService) {
    this.clientId = localStorage.getItem('user_id');
  }

  ngOnInit(): void {
    if (this.data?.assetId && this.clientId) {
      this.fetchCompanyDetails();
      this.fetchRPMDetails();
    }
  }

  get isGear(): boolean {
    return this.data?.assetType === 'GEAR';
  }

  get showFrequency(): boolean {
    return this.data?.subAssetType !== 'DC_MOTOR';
  }

  async fetchCompanyDetails() {
    try {
      this.loadingCompanyDetails = true;
      const apiUrl = `${BaseUrlConstantsService.MONITORING_DEVICE_DETAILS_API}${this.data.assetId}?userId=${this.clientId}&assetType=${this.data.assetType}`;
      const response: any = await this.service.getDataV2(apiUrl);

      if (response?.data?.status === "success") {
        const body = response.data.body;
        this.companyName = body?.companyName?.company_name || "";
        this.siteName = body?.assetDetails?.site_name || "";
        this.applicationName = body?.assetDetails?.application_name || "";
        this.serialNumber = body?.assetDetails?.motor_serial_no || "";
        this.assetName = body?.assetDetails?.name || "";
      }
    } catch (error) {
      console.error("Error fetching company details:", error);
    } finally {
      this.loadingCompanyDetails = false;
    }
  }

  async fetchRPMDetails() {
    try {
      this.loadingRPM = true;
      const apiUrl = `${BaseUrlConstantsService.PIEZO_RPM_DETAILS}${this.data.assetId}/${this.data.parentAssetId}?userId=${this.clientId}&assetType=${this.data.assetType}`;

      const response: any = await this.service.getDataV2(apiUrl);

      if (response?.success === true) {
        // Store the raw data structure to handle the specific UI logic in the template
        this.rpmData = response.data || response.body;
      } else {
        this.rpmData = null;
      }
    } catch (error) {
      console.error("Error loading RPM data", error);
      this.rpmData = null;
    } finally {
      this.loadingRPM = false;
    }
  }

  onInnerNavChange(event: any) {
    this.active_inner_tab = event.nextId;
  }
}
